import { render, staticRenderFns } from "./ProductsDashBoard.vue?vue&type=template&id=92082118&scoped=true&"
import script from "./ProductsDashBoard.vue?vue&type=script&lang=js&"
export * from "./ProductsDashBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92082118",
  null
  
)

export default component.exports